module.exports = __webpack_public_path__ + "img/cegep-beauce-appalache.9cd4ee41.svg";